import React from 'react'
import Grid from '@mui/material/Grid';
import { Container } from '@mui/material';
import { Link } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LogoWhite from "../../assets/images/Logo-white.png";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AppstoreIcon from '../../assets/images/AppstoreIcon.svg';
import PlaystoreIcon from '../../assets/images/PlaystoreIcon.svg';



export default function Footer() {

    const notify = () => toast("Coming soon");


    return (
        <section className='top-home-footer-section'>
            <ToastContainer />
            <Container maxWidth="lg" className='top-home-footer-section-1'>
                <Grid container
                    spacing={3}>
                    <Grid item xs={7} sm={7} md={3} lg={3}>
                        <Link to="/">
                            <LazyLoadImage
                                src={LogoWhite}
                                alt='store'
                                style={{ width: '70%', height: 'auto', display: 'block', marginBottom: "20px" }}
                            />
                        </Link>
                        <Stack
                            spacing={3}
                            direction="row"
                            useFlexGap
                            sx={{ mt: 4 }}
                        >
                            <a rel="noreferrer" href="https://github.com/decosystem" target='_blank'><GitHubIcon /></a>
                            <a rel="noreferrer" href="https://twitter.com/d_ecosystem" target='_blank'><TwitterIcon /></a>
                            <a rel="noreferrer" href="https://www.facebook.com/Desystem.io" target='_blank'><FacebookIcon /></a>
                            <a rel="noreferrer" href="https://www.linkedin.com/in/d-wallet-b722a3237/" target='_blank'><LinkedInIcon /></a>
                        </Stack>
                    </Grid>
                    <Grid item xs={7} sm={7} md={3} lg={3}>
                        <Stack
                            direction="column"
                            useFlexGap
                            sx={{ flexWrap: 'wrap' }}
                        >
                            <Link to="/about">About</Link>
                            <Link to="/attributions">Attributions</Link>
                            <Link to="/cookie-policy">Cookies</Link>
                        </Stack>
                    </Grid>
                    <Grid item xs={7} sm={7} md={3} lg={3}>
                        <Stack
                            direction="column"
                            useFlexGap
                            sx={{ flexWrap: 'wrap' }}
                        >
                            <Link to="/privacy-policy">Privacy Policy</Link>
                            <Link to="/terms">Terms of Use</Link>
                            <Link to="/contact-us">Contact</Link>
                        </Stack>
                    </Grid>

                    <Grid item xs={7} sm={7} md={3} lg={3}>
                        <Link to="https://play.google.com/store/apps/details?id=com.kerdos.wallet" target='_blank'>
                            <LazyLoadImage
                                src={PlaystoreIcon}
                                alt='store'
                                style={{ width: '70%', height: 'auto', display: 'block', marginBottom: "20px" }}
                            />
                        </Link>

                        <Link onClick={notify}>
                            <LazyLoadImage
                                src={AppstoreIcon}
                                alt='store'
                                style={{ width: '70%', height: 'auto', display: 'block' }}
                            /></Link>

                    </Grid>
                </Grid>
            </Container>
        </section>
    )
}
